import goodalipi from '../plugins/goodalipi';
import { _axios } from 'src/plugins/axios';

/**
 * Log out user by deleting variables and clearing session storage
 * Redirects back to '/login' route
 */
export function clearSessionAndRedirect() {
  goodalipi.remove('user');
  goodalipi.remove('isMinor');
  goodalipi.remove('globalHR');
  goodalipi.remove('globalHRgroup');
  sessionStorage.clear();
  window.location.href = '/login';
}

export function sessionExpiredLogout() {
  localStorage.setItem('hrwin_session_expired', '1');
  clearSessionAndRedirect();
}

export function userLogout() {
  _axios.post('authenticate/logout', {}, { ignoreLoading: true });
  clearSessionAndRedirect();
}
